import { useCallback, useEffect, useState } from 'react';
import removeDuplicates from '../../utils/removeDuplicates';
import { FullDataType, WorkplaceType } from './types';

interface IUseMapDataView {
  fullData: FullDataType[];
}

export default function useMapDataView({ fullData }: IUseMapDataView) {
  const [filteredData, setFilteredData] = useState<FullDataType[]>([]);
  const [selectedWorkplace, setSelectedWorkplace] = useState<WorkplaceType>({ value: '', label: 'Selecione um local de trabalho'} as WorkplaceType);
  const [selectedEmployee, setSelectedEmployee] = useState<{ value: string, label: string }>({ value: '', label: 'Selecione um funcionário'} as { value: string, label: string });
  const [workplacesOptions, setWorkplacesOptions] = useState<WorkplaceType[]>([{
    value: '',
    label: 'Selecione um local de trabalho',
    lat: '',
    lng: '',
    cep: '',
    streetName: '',
    number: '',
  }]);
  const [employeesOptions, setEmployeesOptions] = useState([{
    value: '', label: 'Selecione um funcionário'
  }]);
  const [employeesChecked, setEmployeesChecked] = useState<string[]>([]);
  const [selectedColorView, setSelectedColorView] = useState<'criminalRisc' | 'optimizationStatus'>('optimizationStatus');

  const handleSelectedWorkplaceChange = useCallback((workplace: WorkplaceType) => {
    setSelectedWorkplace(workplace);
    setSelectedEmployee({ value: '', label: 'Selecione um funcionário' });
    const employeesAtWorkplace = fullData.filter((employee) =>(
      employee.workplaceCode === workplace.value
    ));
    const mappedEmployeesOptions = employeesAtWorkplace.map((employee) => (
      {
        value: `${employee.cpf} ${employee.name}`,
        label: `Consulta ${employee.consultCode}`,
      }
    ));
    setEmployeesOptions([{
      value: '', label: 'Selecione um funcionário'
    }, ...mappedEmployeesOptions]);
    setFilteredData(employeesAtWorkplace);
  }, [fullData]);

  function handleSelectedEmployeeChange(employee: { value: string, label: string }) {
    setSelectedEmployee(employee);
  }

  function checkEmployee(employee: string) {
    console.log('checkEmployee', employee);
    setEmployeesChecked((prevState) => [...prevState, employee]);
  }

  function uncheckEmployee(employee: string) {
    console.log('ucheckEmployee', employee);
    setEmployeesChecked((prevState) => prevState.filter((item) => item !== employee));
  }

  const defineWorkplacesOptions = useCallback(() => {
    const mappedWorkplaces = [];
    for (let i = 0; i < fullData.length; i++) {
      const index = fullData[i];
      mappedWorkplaces.push({
        value: index.workplaceCode,
        label: index.workplaceName,
        lat: index.workplaceLat,
        lng: index.workplaceLng,
        cep: index.workplaceCep,
        streetName: index.workplaceStreetName,
        number: index.workplaceNumber,
      });
    }

    const allWokplaces = removeDuplicates(mappedWorkplaces);
    setWorkplacesOptions(allWokplaces);

    if (allWokplaces.length === 1) {
      handleSelectedWorkplaceChange(allWokplaces[0]);
    }
  }, [fullData, handleSelectedWorkplaceChange]);

  useEffect(() => {
    defineWorkplacesOptions();
  }, [defineWorkplacesOptions]);

  const downloadDataAsKml = useCallback(() => {
    const kmlAsString = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2" xmlns:gx="http://www.google.com/kml/ext/2.2" xmlns:kml="http://www.opengis.net/kml/2.2" xmlns:atom="http://www.w3.org/2005/Atom">
<Document>
	<name>KML - Mapa de Tendência</name>
	<Snippet maxLines="0"></Snippet>
	<description><![CDATA[<style type='text/css'>*{font-family:Verdana,Arial,Helvetica,Sans-Serif;}</style><table style="width: 300px;"><tr><td style="vertical-align: top;">Source</td><td style="width: 100%;">06.00 as 14.20.xlsx</td></tr><tr><td>DateTime</td><td>2023-06-29 13:33:01 UTC <br/></td></tr><tr><td colspan="2" style="vertical-align: top;"><br/>Created with <a target='_blank' href='https://www.earthpoint.us/ExcelToKml.aspx'>Earth Point Excel To KML</a><br/>&copy;2023 Earth Point<br/><br/>For illustration only.&nbsp; User to verify all information. </td></tr></table>]]></description>
	<Style>
		<IconStyle>
			<Icon>
			</Icon>
		</IconStyle>
		<BalloonStyle>
			<text>$[description]</text>
			<textColor>ff000000</textColor>
			<displayMode>default</displayMode>
		</BalloonStyle>
	</Style>
	<gx:balloonVisibility>1</gx:balloonVisibility>
	<StyleMap id="0_0">
		<Pair>
			<key>normal</key>
			<styleUrl>#Normal0_0</styleUrl>
		</Pair>
		<Pair>
			<key>highlight</key>
			<styleUrl>#Highlight0_0</styleUrl>
		</Pair>
	</StyleMap>
	<Style id="Highlight0_0">
		<IconStyle>
			<color>ffffff00</color>
			<Icon>
				<href>http://www.earthpoint.us/Dots/GoogleEarth/WhiteShapes/house.png</href>
			</Icon>
		</IconStyle>
		<BalloonStyle>
			<text>$[description]</text>
		</BalloonStyle>
		<LineStyle>
			<width>3</width>
		</LineStyle>
	</Style>
	<Style id="Normal0_0">
		<IconStyle>
			<color>ffffff00</color>
			<scale>0.9</scale>
			<Icon>
				<href>http://www.earthpoint.us/Dots/GoogleEarth/WhiteShapes/man.png</href>
			</Icon>
		</IconStyle>
		<BalloonStyle>
			<text>$[description]</text>
		</BalloonStyle>
		<LineStyle>
			<width>2</width>
		</LineStyle>
	</Style>
  <Folder>
  <name>Plan1</name>
  ${filteredData.map((data) => `
  <Placemark>
  <name>&lt;b/&gt;</name>
  <Snippet maxLines="0"></Snippet>
  <description>${data.name} - ${data.cpf}</description>
  <LookAt>
    <longitude>${data.employeeLng}</longitude>
    <latitude>${data.employeeLat}</latitude>
    <altitude>0</altitude>
    <heading>0</heading>
    <tilt>0</tilt>
    <range>1000</range>
    <altitudeMode>relativeToGround</altitudeMode>
  </LookAt>
  <styleUrl>#0_0</styleUrl>
  <Style>
    <LabelStyle>
      <color>00000000</color>
    </LabelStyle>
  </Style>
  <ExtendedData>
  </ExtendedData>
  <Point>
    <coordinates>${data.employeeLng},${data.employeeLat},0</coordinates>
  </Point>
  </Placemark>
  `).join('')}
  </Folder>
  </Document>
  </kml>`;

    const blob = new Blob([kmlAsString], { type: 'application/vnd.google-earth.kml+xml' });

    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = blobUrl;
    a.download = 'KML geolocalizacao (bonecos).kml';

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);

    URL.revokeObjectURL(blobUrl);
  }, [filteredData]);

  return {
    workplacesOptions,
    filteredData,
    selectedWorkplace,
    selectedEmployee,
    employeesOptions,
    handleSelectedWorkplaceChange,
    handleSelectedEmployeeChange,
    employeesChecked,
    checkEmployee,
    uncheckEmployee,
    selectedColorView,
    setSelectedColorView,
    downloadDataAsKml,
  };
}
